<sc-modal-wizard size="lg" #modal>

	<sc-modal-header>
		<div class="row">
			<div class="col">
				<span *ngIf="activeTab != 'type'" class="oneline">{{ texts.header[language] }}</span>
				<span *ngIf="activeTab == 'type'" class="oneline">{{ texts.typeQuestion[language] }}</span>
			</div>
		</div>
	</sc-modal-header>

	<sc-modal-header [showClose]="false" *ngIf="activeTab != 'type'">
		<ul class="nav nav-tabs" *ngIf="activeTab != 'confirmation'">
			<li class="nav-item" *ngFor="let tab of visibleTabs; let i = index;">
				<a class="nav-link" [class.active]="tab.id == activeTab" [class.disabled]="!tab.isEnabled"
					(click)="selectTab(tab)">

					<div class="row align-items-center">
						<div class="col pe-0">
							<div class="numbering-container">
								<div class="small">
									{{ i + 1 }}
								</div>
							</div>
						</div>
						<div class="col">
							{{ tab.text[language] }}
						</div>
					</div>

				</a>
			</li>
		</ul>
		<div class="confirmation-container" *ngIf="activeTab == 'confirmation'">

			<div class="row align-items-center">
				<div class="col-auto pe-0">
					<div class="numbering-container success">
						<div class="small">
							<i class="fa-solid fa-check fa-xs"></i>
						</div>
					</div>
				</div>
				<div class="col-auto">
					<span class="oneline">{{ texts.thankYou[language] }}</span>
				</div>
			</div>

		</div>
	</sc-modal-header>

	<sc-modal-wizard-page #typePage>

		<sc-modal-body *ngIf="project">
			

			<div class="list-group" style="max-width: 60rem;">

				<a class="list-group-item list-group-item-action" [class.active]="selectedType == 'Longlist'"
					(click)="selectType('Longlist')">
					<h6 class="mb-1">{{ texts.typeLonglist[language] }}</h6>
					<div class="small text-muted">{{ texts.typeLonglistBody[language] }}</div>
				</a>

				<a class="list-group-item list-group-item-action" [class.active]="selectedType == 'Full'"
					(click)="selectType('Full')">
					<h6 class="mb-1">{{ texts.typeOutreach[language] }}</h6>
					<div class="small text-muted">{{ texts.typeOutreachBody[language] }}</div>
				</a>

			</div>

		</sc-modal-body>
		<sc-modal-footer>
			<button class="btn btn-round btn-dark" (click)="showDetails()">{{ texts.next[language] }}</button>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page [definesHeight]="true" #start>

		<sc-modal-body *ngIf="project">
			<sc-form>

				<sc-form-row [label]="texts.jobTitle[language]">
					<input [(ngModel)]="project.Name" />
				</sc-form-row>

				<sc-form-row [label]="texts.locations[language]">
					<sc-editor-location-list [(locations)]="project.Profile.Locations"
						[language]="language"></sc-editor-location-list>
				</sc-form-row>

				<sc-form-row [label]="texts.salary[language]" *ngIf="!isSalaryHidden(project?.Id)">
					<div class="row align-items-center w-100">
						<div class="col">
							<input name="MinSalary" type="text" inputmode="numeric" [ngModel]="minSalaryInput"
								(ngModelChange)="onMinSalaryChange($event)" />
						</div>
						<div class="col-auto px-0">
							{{ texts.to[language] }}
						</div>
						<div class="col">
							<input name="MaxSalary" type="text" inputmode="numeric" [ngModel]="maxSalaryInput"
								(ngModelChange)="onMaxSalaryChange($event)" />
						</div>
						<div class="col-2 ps-0">
							<input name="SalaryCurrency" [(ngModel)]="project.Profile.Compensation.SalaryCurrency" />
						</div>
					</div>
				</sc-form-row>

				<sc-form-row [label]="texts.remoteShare[language]">
					<input [(ngModel)]="project.Profile.MaxRemote" type="number" />
				</sc-form-row>

				<sc-form-row [label]="texts.employmentType[language]">
					<select class="custom-select custom-select-sm" [(ngModel)]="project.Profile.EmploymentType">
						<option value="Permanent">{{ texts.employmentPermanent[language] }}</option>
						<option value="Interim">{{ texts.employmentInterim[language] }}</option>
						<option value="Freelancer">{{ texts.employmentFreelancer[language] }}</option>
						<option value="SelfEmployed">{{ texts.employmentSelfEmployed[language] }}</option>
						<option value="Internship">{{ texts.employmentInternship[language] }}</option>
					</select>
				</sc-form-row>

				<sc-form-row [label]="texts.fullTimeLabel[language]">
					<select class="custom-select custom-select-sm" [(ngModel)]="project.Profile.IsFullTime">
						<option [ngValue]="true">{{ texts.yes[language] }}</option>
						<option [ngValue]="false">{{ texts.no[language] }}</option>
					</select>
				</sc-form-row>

				<sc-form-row [label]="texts.partTimeLabel[language]">
					<select class="custom-select custom-select-sm" [(ngModel)]="project.Profile.IsPartTime">
						<option [ngValue]="true">{{ texts.yes[language] }}</option>
						<option [ngValue]="false">{{ texts.no[language] }}</option>
					</select>
				</sc-form-row>

			</sc-form>

		</sc-modal-body>
		<sc-modal-footer>
			<div class="row w-100 align-items-center">
				<div class="col">
					<button class="btn btn-round btn-secondary" (click)="showType()">{{ texts.back[language] }}</button>
				</div>
				<div class="col-auto">
					<button class="btn btn-round btn-dark" (click)="showNextFromDetails()">{{ texts.next[language]
						}}</button>
				</div>
			</div>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #jobsite>

		<sc-modal-body *ngIf="project">
			<div class="mb-3">{{ texts.jobsiteCheck[language] }}</div>
			<a class="btn btn-secondary" (click)="showJobsiteReview()">{{ texts.viewJobsite[language] }}<i
					class="fa-sharp fa-solid fa-arrow-right ms-2"></i></a>
		</sc-modal-body>
		<sc-modal-footer>
			<button class="btn btn-round btn-dark" (click)="showComment()">{{ texts.next[language] }}</button>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #commentPage>
		<sc-modal-body>
			<div class="row align-items-center">
				<div class="col">
					<div class="mb-3">{{ texts.anythingToTell[language] }}</div>
					<textarea class="form-control" rows="6" [(ngModel)]="comment"></textarea>
				</div>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<div class="row w-100 align-items-center">
				<div class="col">
					<button class="btn btn-round btn-secondary" (click)="showBackFromComment()">{{ texts.back[language]
						}}</button>
				</div>
				<div class="col-auto">
					<button class="btn btn-round btn-dark" (click)="startProject()" [class.loading]="isStarting">{{
						texts.startPaid[language] }}</button>
				</div>
			</div>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #confirmation>
		<sc-modal-body>
			<div class="row h-100 align-items-center">
				<div class="col-8 offset-2 text-center">
					<p>
						{{ texts.processed[language] }}
					</p>
				</div>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<button class="btn btn-round btn-secondary" (click)="modal.dismiss()">{{ texts.close[language] }}</button>
		</sc-modal-footer>
	</sc-modal-wizard-page>

</sc-modal-wizard>